import { useNavigate } from 'react-router-dom';
import { Crown } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

// HeaderCTA — extraído de Header.jsx en P3.1 refactor (feb-2026).
// Contiene los badges de plan: corona del Creator (admin).
// La corona Premium pequeña se eliminó del header (feb-2026) por feedback
// de Owner — generaba confusión a los usuarios. La representación oficial
// de Premium es la corona rosa de PremiumCrownBadge en el Workspace.
// Si futuro: aquí iría también un botón "Upgrade Premium".
const HeaderCTA = ({ isLoggedIn, isCreator }) => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  if (!isLoggedIn) return null;

  return (
    <>
      {/* Creator Panel - only for creator — visible tambien en mobile */}
      {isCreator && (
        <button
          onClick={() => navigate('/admin/creator')}
          className="p-1 sm:p-2 rounded-lg bg-gradient-to-r from-amber-500/20 to-orange-500/20 hover:from-amber-500/30 hover:to-orange-500/30 border border-amber-500/40 hover:border-amber-400/60 transition-all duration-200 text-amber-400 hover:text-amber-300"
          title={language === 'es' ? 'Panel del Creador' : 'Creator Panel'}
          data-testid="creator-panel-btn"
        >
          <Crown className="w-4 h-4 sm:w-5 sm:h-5" strokeWidth={1.5} />
        </button>
      )}
    </>
  );
};

export default HeaderCTA;
